<section class="empathy-simulator">
  <div empathyPreviewDevice class="empathy-simulator__frame" [ngClass]="previewDevices[activeDevice].cssClass">
    <div class="empathy-simulator__frame__silencer"></div>
    <div class="empathy-simulator__frame__volume-up"></div>
    <div class="empathy-simulator__frame__volume-down"></div>
    <div class="empathy-simulator__frame__button-on"></div>
    <div class="empathy-simulator__frame__inside-border">
      <div class="device-wrapper__toolbar">
        <!-- Camera -->

        <div class="camera">
          <div class="camera-dot">
            <div class="camera-dot-2"></div>
            <div class="camera-dot-3"></div>
          </div>
          <div class="camera-speaker"></div>
        </div>

        <!-- Battery and Signal -->

        <div class="t-r-info">
          <div class="dots">...</div>
          <div class="battery">
            <div class="bar"></div>
          </div>
        </div>
      </div>

      <!-- Data -->
      <div class="device-wrapper__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>